import $utils from '@/utils/utils'
import $api from '@/http/api'
import $common from '../common'
import $router from '@/router'
import { Dialog } from 'vant'

export default {
	namespaced: true,
	state: {
		token: '',
		openid: '',
		unionid: '',
		patientId: '',
		serveDateTime: '0',
		patientInfo: {},
		myPagePatientId: '' //个人中心页面健康档案选中的患者id
	},
	getters: {
		getToken: state => $common.storeGetterLocalCommon(state, 'token'),
		getOpenid: state => $common.storeGetterLocalCommon(state, 'openid'),
		getUnionid: state => $common.storeGetterLocalCommon(state, 'unionid'),
		getPatientId: state => $common.storeGetterLocalCommon(state, 'patientId'),
		getMyPagePatientId: state => state.myPagePatientId,
		patientInfo: state => $common.storeGetterSessionCommon(state, 'patientInfo', 'object')
	},
	mutations: {
		['SET_TOKEN'](state, token) {
			state.token = token
			window.localStorage.setItem('token', token)
		},
		['SET_OPENID'](state, openid) {
			state.openid = openid
			window.localStorage.setItem('openid', openid)
		},
		['SET_UNIONID'](state, unionid) {
			state.unionid = unionid
			window.localStorage.setItem('unionid', unionid)
		},
		['SET_PATIENT_ID'](state, val) {
			state.patientId = val
			window.localStorage.setItem('patientId', val)
		},
		['SET_PATIENT_INFO'](state, val) {
			state.patientInfo = val
			window.sessionStorage.setItem('patientInfo', JSON.stringify(state.patientInfo))
		},
		['SET_SERVE_DATETIME'](state, val) {
			state.serveDateTime = val
		},
		['SET_MY_PAGE_PATIENT_ID'](state, val) {
			console.log(val)
			state.myPagePatientId = val
		},
		['CLEAR'](state) {
			Object.keys(state).forEach(key => {
				if (typeof state[key] === 'string') state[key] = ''
				else if ($utils.isArray(state[key])) state[key] = []
				else state[key] = {}
			})
			window.localStorage.removeItem('patientId')
			window.sessionStorage.clear()
		}
	},
	actions: {
		// 切换|获取患者档案信息
		async actionSwitchPatient({ commit }, { params, callback, dialog = true }) {
			const res = await $api.patient.switchPatient(params)
			const res1 = await $api.patient.getPatientRelatedData(params)
			const res2 = await $api.patient.getNotReadeNumber({
				patientId: params,
				readStatus: 0,
				page: 1,
				limit: 1
			})
			if (!res.code && !res1.code && !res2.code) {
				let baseData = res.data
				baseData.approveStatus = res.data.informationAnswer ? 1 : 0
				baseData.messageNumber = res2.data && res2.data.length > 0 ? true : false
				const data = Object.assign(baseData, res1.data)
				commit('SET_PATIENT_INFO', data)
				commit('SET_PATIENT_ID', params)
				// TODO：
				if (dialog && !baseData.approveStatus) {
					Dialog.confirm({
						title: '温馨提示',
						message: '当前档案未完成基础信息填写，是否现在补充',
						confirmButtonText: '立即填写',
						cancelButtonText: '暂不填写'
					})
						.then(() => $router.push(`/health/base/${params}`))
						.catch(() => {})
				}
				callback && callback(data)
			}
			this.dispatch('information/apiGetInformationStatus', { params }, { root: true })
		},
		// 获取当前服务器时间的时间戳
		async actionGetDateTime({ commit }) {
			const res = await $api.account.getDateTime()
			if (!res.code) {
				commit('SET_SERVE_DATETIME', res.data)
			}
		}
	}
}
